import { Params, ParamValue } from './types'

/**
 * Converts an object into a querystring
 *
 * @param {Params} params An object like { q: 'foo', skip: 0, take: 50 }
 * @param {boolean} encode Should the param names and values be URI encoded? Set to false for performance gains if you are sure the names and values are URI safe.
 * @return {string} A string like q=foo&skip=0&take=50
 */
export default (params: Params, encode: boolean = true) => {
	const endocer = encode ? encodeURIComponent : (s: string) => s
	return Object.keys(params)
		.reduce((arr, paramName) => {
			const value = params[paramName]
			if (value !== undefined) {
				const name = endocer(paramName)
				if (Array.isArray(value)) {
					// When the array is empty, send an empty element.
					if (value.length === 0) {
						arr.push(`${name}=`)
					} else {
						value.forEach((itemValue) => {
							arr.push(`${name}=${endocer(paramValueToString(itemValue))}`)
						})
					}
				} else {
					arr.push(`${name}=${endocer(paramValueToString(value))}`)
				}
			}
			return arr
		}, [] as string[])
		.join('&')
}

const paramValueToString = (value: ParamValue) => {
	if (value === undefined || value === null) {
		return ''
	}
	return value.toString()
}
